<template>
  <div class="index-page container pt-5 d-flex flex-column justify-content-center align-items-center">
    <section class="main d-flex flex-column align-items-center justify-content-center text-center mt-5">
      <div class="index-page__title mt-5 mb-3 text-center">
        {{ $t('header.title') }}
      </div>

      <p class="index-page__text text-center mb-4 mt-sm-3">
        {{ $t('header.subtitle') }}
      </p>

      <div class="btn-call">
        <router-link tag="button" :to="{ name: 'contact' }">
          <span class="mx-2">{{ $t('button.contact') }}</span>
          <img src="../assets/images/call-ico.png" alt="Call ico">
        </router-link>
      </div>

      <div class="index-page__image d-flex justify-content-center align-items-center text-center">
        <b-img class="d-none d-md-block " :src="img" alt="Responsive image"></b-img>
        <b-img class="d-sm-block d-md-none" :src="imgMobile" alt="Responsive image"></b-img>
      </div>
    </section>

    <div class="d-block mt-5 mb-5 pt-5 pb-5"></div>
    <div class="d-block mt-md-5 mb-md-5 pt-md-5 pb-md-5"></div>
    <div class="d-block mt-md-5 mb-md-5 pt-md-5 pb-md-5"></div>
    <div class="d-block mt-5 mb-5"></div>

    <section id="about_us" class="d-block mb-0 pt-5 pb-5">

      <div class="d-flex flex-column text-center">
        <h1 class="heading mb-2">{{ $t('about_us.title') }}</h1>

        <p class="m-4">{{ $t('about_us.text') }}</p>
      </div>

      <div class="second-part d-flex flex-column text-center mt-5">
        <h1 class="heading mb-5">{{ $t('projects.title') }}</h1>

        <div>
          <div class="row justify-content-center align-items-center">
            <div class="col-12 col-md-6">
              <b-card no-body class="overflow-hidden border-0 first-card" style="max-width: 100%;">
                <b-row no-gutters class="project-card">
                  <b-col md="6" class="px-0">
                    <b-card-body class="text-start" title="">
                      <img src="../assets/images/Paymart.png" alt="logo" height="40">

                      <h1 class="card-title mt-2 pt-2">{{ $t('projects.installment_service.title') }}</h1>

                      <b-card-text class="pt-2 mt-2">
                        {{ $t('projects.installment_service.subtitle') }}
                      </b-card-text>
                    </b-card-body>
                  </b-col>

                  <b-col md="6" class="first-card__body px-0">
                    <b-card-img
                        :src="installment"
                        alt="Image"
                        class="rounded-0 d-none d-md-block"
                    ></b-card-img>
                    <b-card-img
                        :src="installmentSmall"
                        alt="Image"
                        class="rounded-0 d-block d-md-none"
                    ></b-card-img>
                  </b-col>
                </b-row>
              </b-card>
            </div>

            <div class="col-12 col-md-6">
              <b-card no-body class="overflow-hidden border-0 first-card" style="max-width: 100%;">
                <b-row no-gutters class="project-card">
                  <b-col md="6">
                    <b-card-body class="text-start" title="">
                      <img src="../assets/images/Paycart.png" alt="Paycart logo" height="40">
                      <h1 class="card-title mt-2 pt-2">{{ $t('projects.marketplace.title') }}</h1>
                      <b-card-text class="pt-2 mt-2">{{ $t('projects.marketplace.subtitle') }}</b-card-text>
                    </b-card-body>
                  </b-col>

                  <b-col md="6" class="first-card__body">
                    <b-card-img
                        :src="marketplace"
                        alt="Image"
                        class="rounded-0 d-none d-md-block"
                    ></b-card-img>
                    <b-card-img
                        :src="marketplace"
                        alt="Image"
                        style="width: 140px;"
                        class="rounded-0 d-block d-md-none"
                    ></b-card-img>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </div>

          <b-card no-body class="overflow-hidden mt-4 payment-system-card" style="max-width: 100%;">
            <b-row no-gutters>
              <b-col md="6">
                <b-card-body class="text-start">
                  <img src="../assets/images/Payz.png" alt="Payz ico" height="40">
                  <h3 class="mt-2 mb-2" style="font-weight: bold; font-size: 24px;">
                    {{ $t('projects.payment_system.title') }}
                  </h3>
                  <b-card-text>
                    {{ $t('projects.payment_system.subtitle') }}
                  </b-card-text>
                </b-card-body>
              </b-col>
              <b-col md="6" class="mt-5">
                <img src="../assets/images/projects/payment.webp" alt="Image" class="rounded-0"
                     height="255">
              </b-col>
            </b-row>
          </b-card>

        </div>
      </div>
    </section>

    <section v-if="partnerLogos.length" id="partners" class="container pt-5 mb-5">
      <h1 class="text-center mb-5" style="font-weight: bold; font-size: 40px;">{{ $t('partners.title') }}</h1>

      <div v-if="isLoading" class="row">
        <div v-for="item in 4" :key="item" class="col-md-3">
          <b-skeleton class="rounded-3" height="200px" animation="fade"></b-skeleton>
        </div>
      </div>

      <Swiper v-else class="swiper d-flex justify-content-center align-items-center" :options="swiperOption">
        <swiper-slide v-for="(logo, index) in partnerLogos" :key="index" class="logo-slide">
          <img
              class="logo-slide__img"
              :class="{ 'myclass' : isAddClass }"
              :src="logo"
              :alt="`partners logos ${index}`"
              :style="{ width: index === 0 ? '50%' : '100%' }"
              @click="addClass"
          >
        </swiper-slide>
      </Swiper>
    </section>

    <section id="certificates">
      <div class="d-flex align-items-center justify-content-center mb-md-5 mt-md-5 container">
        <h1 class="" style="font-weight: bold; font-size: 40px;">
          {{ $t('certificates.title') }}
        </h1>

<!--        <router-link :to="{ name: 'certificates' }" class="d-flex align-items-center text-decoration-none"-->
<!--                     style="color: #6DB8FF">-->
<!--          <span class="d-md-block d-none me-1 mb-1">{{ $t('button.view_all') }}</span>-->
<!--          <ChevronRightIcon color="#6DB8FF"></ChevronRightIcon>-->
<!--        </router-link>-->
      </div>

      <div class="row d-flex justify-content-center align-items-center">

        <div class="col-12 col-md-6">
          <b-card no-body class="overflow-hidden card-certificate border-0">
            <b-row no-gutters>

              <b-col md="6">
                <b-card-body class="text-start certificate-text">
                  <h2 class="text-nowrap" style="font-size: 24px">{{ $t('certificates.halyal.title') }}</h2>
                  <b-card-text>{{ $t('certificates.halyal.text') }}</b-card-text>
                </b-card-body>
              </b-col>

              <b-col md="6" class="certificate d-none d-md-block">
                <img src="../assets/images/certificate.png" alt="Image"
                     class="rounded-0 certificate-img">
              </b-col>

              <b-col md="6" class="certificate d-block d-md-none">
                <img src="../assets/images/mobile-certificate-new.png" alt="certificate"
                     class="rounded-0 certificate-img">
              </b-col>

            </b-row>
          </b-card>
        </div>

        <div class="col-12 col-md-6">
          <b-card no-body class="overflow-hidden card-certificate border-0">
            <b-row no-gutters>

              <b-col md="6">
                <b-card-body class="text-start certificate-text">
                  <h2 class="text-nowrap" style="font-size: 24px">{{ $t('certificates.company.title') }}</h2>
                  <b-card-text>{{ $t('certificates.company.text') }}</b-card-text>
                </b-card-body>
              </b-col>

              <b-col md="6" class="certificate d-none d-md-block">
                <img src="../assets/images/sertificate-new.jpg" alt="Image"
                     class="rounded-0 certificate-img__unique">
              </b-col>

              <b-col md="6" class="certificate d-block d-md-none">
                <img src="../assets/images/sertificate-new.jpg" alt="Image"
                     class="rounded-0 certificate-img__unique-mobile">
              </b-col>

            </b-row>
          </b-card>
        </div>

        <div class="col-12 col-md-6 my-3">
          <b-card no-body class="overflow-hidden card-certificate border-0">
            <b-row no-gutters>

              <b-col md="6">
                <b-card-body class="text-start certificate-text">
                  <h2 class="text-nowrap" style="font-size: 24px">
                    {{ $t('certificates.international_identification.title') }}</h2>
                  <b-card-text>{{ $t('certificates.international_identification.text') }}</b-card-text>
                </b-card-body>
              </b-col>

              <b-col md="6" class="certificate d-none d-md-block">
                <img src="../assets/images/сертификат_АО_SL_международная_идентификация-1.png" alt="Image"
                     class="rounded-0 certificate-img__unique" height="300">
              </b-col>

              <b-col md="6" class="certificate d-block d-md-none">
                <img src="../assets/images/сертификат_АО_SL_международная_идентификация-1.png" alt="Image"
                     class="rounded-0 certificate-img__unique-mobile" height="200">
              </b-col>

            </b-row>
          </b-card>
        </div>

        <div class="col-12 col-md-6 my-3">
          <b-card no-body class="overflow-hidden card-certificate border-0">
            <b-row no-gutters class="gov-card">

              <b-col md="6">
                <b-card-body class="text-start certificate-text py-sm-1 py-md-5">
                  <h2 class="text-nowrap" style="font-size: 24px">{{ $t('certificates.it_park.title') }}</h2>
                  <b-card-text>{{ $t('certificates.it_park.text') }}</b-card-text>
                </b-card-body>
              </b-col>

              <b-col md="6" class="certificate d-none d-md-block">
                <img cl src="../assets/images/it-park.jpg" alt="Image"
                     class="rounded-0 certificate-img__it" height="400">
              </b-col>

              <b-col md="6" class="certificate d-block d-md-none">
                <img src="../assets/images/it-park.jpg" alt="Image"
                     class="rounded-0 certificate-img__it-mobile" height="200">
              </b-col>

            </b-row>
          </b-card>
        </div>
      </div>

      <div class="row solution-section">
        <div class="col-12 col-md-6 d-flex flex-column text-start justify-content-center p-4">
          <h1 class="solution-section__tcard-cerle text-start">{{ $t('career.title') }}</h1>
          <p class="solution-section__text">{{ $t('career.text') }}</p>

          <div class="solution__btn">
            <router-link tag="button" class="solution-section__btn" :to="{name: 'vacancies'}">
              {{ $t('button.more') }}
              <img src="../assets/images/arrow-btn.png" alt="Arrow icon">
            </router-link>
          </div>
        </div>

        <div class="col-12  col-md-6">
          <img class="d-none d-md-block" src="../assets/images/career/workers.webp" alt="Solution image">
          <img class="d-block d-md-none" src="../assets/images/career/workers-small.webp"
               alt="Solution image mobile">
        </div>
      </div>
    </section>

    <section class="contacts">
      <b-row class="contacts__row">
        <b-col class="contacts__row__requisites d-flex flex-column justify-content-center" md="4">

          <h1 class="mb-4">{{ $t('contacts.title') }}</h1>

          <TheContactsList></TheContactsList>

        </b-col>

        <b-col class="contacts__row__map ml-auto" md="8">
          <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2996.5721998151594!2d69.29683861572548!3d41.31816930824568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38aef5796b3bbbd9%3A0x3b9b4861990630b1!2sGalleon%20Business%20Center!5e0!3m2!1sru!2s!4v1680606373290!5m2!1sru!2s"
              width="100%"
              height="360"
              title="company address"
              style="border:0; border-radius: 14px"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </b-col>
      </b-row>
    </section>

  </div>
</template>

<script>
import 'swiper/css/swiper.min.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

// header images
import img from '../assets/images/header/additional_background.webp';
import imgMobile from '../assets/images/header/additional-mobile.webp';

// projects
import installment from '../assets/images/projects/installment-service.webp';
import installmentSmall from '../assets/images/projects/installment-service-small.webp';
import marketplace from '../assets/images/projects/marketplace.webp';

import certificateImage from '../assets/images/certificate.png';

import { getPartnersImages } from '@/services/partner';

import TheContactsList from '@/components/TheContactsList';

import ChevronRightIcon from '@/components/svg/ChevronRightIcon';

export default {
  name: 'home',
  components: {
    Swiper,
    SwiperSlide,
    ChevronRightIcon,
    TheContactsList,
  },
  data() {
    return {
      img,
      imgMobile,
      installment,
      installmentSmall,
      marketplace,
      certificateImage,
      partnerLogos: [],
      isLoading: false,
      swiperOption: {
        slidesPerView: 8,
        spaceBetween: 20,
        freeMode: true,
        autoplay: {
          delay: 2000,
        },
        breakpoints: {
          // when window width is >= 320px
          200: { slidesPerView: 1.7, spaceBetween: 10, freeMode: false },
          // when window width is >= 480px
          576: {
            slidesPerView: 1.7,
            spaceBetween: 10,
            freeMode: false,
          },
          // when window width is >= 640px
          768: { slidesPerView: 2, spaceBetween: 32, freeMode: false },
          992: { slidesPerView: 3, spaceBetween: 32 },
          1200: { slidesPerView: 5, spaceBetween: 20 },
        },
      },
      isAddClass: false,
    };
  },
  methods: {
    addClass: function () {
      this.isAddClass = !this.isAddClass;
    },
  },
  async mounted() {
    this.isLoading = true;

    this.partnerLogos = await getPartnersImages();

    this.isLoading = false;
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/mixins/_font.scss";

.main {
  max-width: 70%;
  color: #fff;
  font-family: Gilroy, sans-serif;
  text-align: center;

  .index-page {
    &__title {
      font-weight: 700;
      font-size: 56px;
      line-height: 120%;
      @media (max-width: $mobile) {
        font-size: 32px;
        width: 117%;
      }
    }

    &__text {
      font-size: 17px;
      line-height: 120%;
      width: 75%;
      text-align: center;
      font-weight: 400;

      @media (max-width: $mobile) {
        font-size: 14px;
        width: 121%;
        text-align: center;
      }
    }

    &__image {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        position: absolute;
        top: 20%;
      }

      @media (max-width: $mobile) {
        img {
          position: absolute;
          margin-top: 86px;
          top: 20%;
          max-width: 343px;
        }
      }
    }
  }

  .btn-call {
    button {
      border: none;
      padding: 14px 16px;
      border-radius: 32px;
      background-color: #fff;
    }
  }
}

.heading {
  font-weight: bold;
  font-size: 40px;
}

.first-card, .second-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 40px 0 40px 40px;
  transition: box-shadow .5s linear;

  @media(max-width: $mobile) {
    margin: 17px;
    padding: 20px 20px;
  }

  &:hover {
    box-shadow: 50px 60px 80px rgba(115, 137, 149, 0.12);
  }

  &__body {
    padding-top: 110px;
    padding-bottom: 40px;
  }
}

.text-start {
  /*padding: 40px;*/
  h1 {
    /*padding-top: 40px;*/
    white-space: nowrap;
  }
}

.card-title {
  font-weight: bold;
  font-size: 24px;
}

.payment-system-card {
  border: none;
  border-radius: 16px;
  padding: 40px 40px 0 40px;
  transition: box-shadow .5s linear;

  @media(max-width: $mobile) {
    margin: 17px;
    padding: 20px 20px 0 20px;
  }

  &:hover {
    box-shadow: 50px 60px 80px rgba(115, 137, 149, 0.12);
  }
}

#partners {
  .logo-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    background-color: white;
    border-radius: 12px;
    padding: 8px;

    &__img {
      width: 100%;
      //mix-blend-mode: multiply;
    }
  }
}

.card-certificate {
  border-radius: 16px;
  height: 400px;
  transition: box-shadow .5s linear;

  @media(max-width: $mobile) {
    margin: 17px;
    height: 336px;
  }

  &:hover {
    box-shadow: 50px 60px 80px rgba(115, 137, 149, 0.12);
  }

  &__IT {
    margin-top: 30px;
    border-radius: 16px;
    transition: box-shadow .5s linear;

    @media(max-width: $mobile) {
      margin: 17px;
    }

    &:hover {
      box-shadow: 50px 60px 80px rgba(115, 137, 149, 0.12);
    }
  }

  .certificate-img {
    margin-top: 70px;
    margin-left: -60px;
    /*height: 320px;*/
    @media(max-width: $notebook) {
      margin-top: 91px;
      margin-left: -41%;
    }
    @media(max-width: $mobile) {
      margin-top: -67px;
      margin-left: 16px !important;
    }

    &__unique {
      -ms-transform: rotate(20deg); /* IE 9 */
      margin-top: 157px;
      margin-left: 98px;
      transform: rotate(-17deg);
      height: 300px;
    }

    &__unique-mobile {
      margin-top: -15px;
      margin-left: 93px;
      transform: rotate(-11deg);
      height: 200px;
    }

    @media(max-width: $mobile) {
      margin-top: -67px;
      margin-left: -69px;
    }
  }
}

.certificate-text {
  margin: 80px 0 80px 40px;
  @media(max-width: $mobile) {
    margin: 10px 0 10px 5px;
  }
}

.solution {
  &-section {
    /*display: flex;*/
    /*justify-content: space-between;*/
    /*align-items: center;*/
    margin-top: 100px;

    &__title {
      font-weight: bold;
      font-size: 40px;
      @media(max-width: $mobile) {
        font-size: 24px;
      }
    }

    &__text {
    }

    &__btn {
      border: none;
      border-radius: 32px;
      background-color: #6DB8FF;
      color: #fff;
      padding: 18px 24px;
      margin-top: 40px;

      img {
        margin-left: 10px;
        border-radius: 50%;
        background-color: #fff;
        padding: 9px;

        &:hover {
          box-shadow: 50px 60px 80px rgba(115, 137, 149, 0.12) !important;
        }
      }
    }
  }
}

.solution-section {

  &__text, &__title {
    @media(max-width: $mobile) {
      margin: 7px 17px;
      &__btn {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .solution__btn {
    @media(max-width: $mobile) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.contacts {
  margin: 150px 0 175px 0;

  @media (max-width: $mobile) {
    margin: 47px 0 53px 0;
  }

  &__row {
    &__requisites {
      h1 {
        @include font(40px, 700, 48px)
      }
    }

    &__map {
    }
  }
}

.certificate-img__it {
  margin-left: 51px;
  transform: rotate(-111deg);
  /*box-shadow: 50px 60px 80px rgba(115, 137, 149, 0.12);*/
}

.certificate-img__it-mobile {
  margin-left: 86px;
  transform: rotate(-90deg);
}

.project-card {
  height: 355px;
  @media(max-width: $mobile) {
    height: 100%;
  }
}

.gov-card {
  height: 400px;
}
</style>